import * as ResizablePrimitive from 'react-resizable-panels';
import styles from './Resizable.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const ResizablePanelGroup = ({ className = '', ...props }) => (
  <ResizablePrimitive.PanelGroup
    className={`${styles.panelGroup} ${className}`}
    {...props}
  />
);

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableHandle = ({ withHandle, className = '', ...props }) => (
  <ResizablePrimitive.PanelResizeHandle
    className={`${styles.handle} ${className}`}
    {...props}
  >
    {withHandle && (
      <div className={styles.handleGrip}>
        {/* <GripVertical size={12} /> */}
        <SvgWithBranding type="draggable" />
      </div>
    )}
  </ResizablePrimitive.PanelResizeHandle>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
